'use strict';

/**
 *  Load modules
 */
import burgerMenu from './modules/burgerMenu';
import directoryMap from './modules/directoryMap';

document.addEventListener("DOMContentLoaded", () => {
    directoryMap();
});
